import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import UpdateSnapshot from './UpdateSnapshot';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UpdateSnapshot />
  </React.StrictMode>
);

